
    import { mapState } from 'vuex';
    import CompanyLogo from '@/components/Company/CompanyLogo';
    import JobViewBrandLocation from '@/components/JobView/JobViewBrandLocation';
    import JobViewMixin from '@/components/JobView/Mixins/JobViewMixin.vue';
    import JobViewApplyCta from '@/components/JobView/JobViewApplyCta';
    import ScoreButton from '@/components/Scoring/ScoreButton';
    import JobSave from '@/components/Job/JobSave';

    export default {
        name: 'JobViewCtaFlier',

        components: {
            CompanyLogo,
            JobViewBrandLocation,
            JobViewApplyCta,
            ScoreButton,
            JobSave,
        },

        mixins: [JobViewMixin],

        data() {
            return {
                showPromptModal: false,
                onBoardingPrompt: {
                    component_name: 'OnBoardingPrompt',
                    layout: 'lg',
                    code: 'ON_BOARDING_PROMPT',
                    page_referral_element: 'score_button',
                },
            };
        },

        computed: {
            ...mapState({
                $_isApplyEnabled: state => state.job.is_apply_enabled,
                $_jobApplication: state => state.jobApplication,
            }),
        },

        methods: {
            openPromptModal() {
                this.showPromptModal = true;
            },
            closePromptModal() {
                this.showPromptModal = false;
            },
        },
    };
